module.exports = __webpack_public_path__ + "img/squares_grey.b5395df6.svg";